import { VersionableId } from '../../../../types/versionableId';
import { useAppSelector } from '../../../../store/hooks';
import { FormMode } from '../../../../types/formMode';
import { selectSelectedSchema } from '../../../../store/schemas/schemasSelector';
import Drawer from '@mui/material/Drawer';
import { makeStyles } from '@mui/styles';
import EsmeAddFormContainer from './EsmeAddFormContainer';
import EsmeViewFormContainer from './EsmeViewFormContainer';
import EsmeEditFormContainer from './EsmeEditFormContainer';
import Alert from '@mui/material/Alert';

const useStyles = makeStyles({
  drawerPaper: {
    width: '60%',
  },
});

const UndefinedSchemaAlert = () => (
  <Alert severity='error'>Error: Cannot open form due to schema is undefined!</Alert>
);

const UndefinedEsmeIdAlert = () => (
  <Alert severity='error'>Error: Cannot open form due to esmeId is undefined!</Alert>
);

const EsmeFormContainer = (props: {
  readonly isOpen: boolean;
  readonly formMode: FormMode;
  readonly esmeId?: VersionableId;
  readonly hideEsmeForm: () => void;
}) => {
  const {
    isOpen,
    formMode,
    esmeId,
    hideEsmeForm,
  } = props;

  const classes = useStyles();
  const selectedSchema = useAppSelector(selectSelectedSchema);

  const renderAddingEsmeForm = () => {
    if (!selectedSchema) {
      return <UndefinedSchemaAlert />;
    }

    return (
      <EsmeAddFormContainer
        schema={selectedSchema}
        hideEsmeForm={hideEsmeForm}
      />
    );
  };

  const renderViewingEsmeForm = () => {
    if (!esmeId) {
      return <UndefinedEsmeIdAlert />;
    }

    return (
      <EsmeViewFormContainer
        esmeId={esmeId}
        hideEsmeForm={hideEsmeForm}
      />
    );
  };

  const renderEditingEsmeForm = () => {
    if (!selectedSchema) {
      return <UndefinedSchemaAlert />;
    }
    if (!esmeId) {
      return <UndefinedEsmeIdAlert />;
    }

    return (
      <EsmeEditFormContainer
        schema={selectedSchema}
        esmeId={esmeId}
        hideEsmeForm={hideEsmeForm}
      />
    );
  };

  const renderForm = {
    [FormMode.ADD]: renderAddingEsmeForm,
    [FormMode.VIEW]: renderViewingEsmeForm,
    [FormMode.EDIT]: renderEditingEsmeForm,
  }[formMode];

  return (
    <Drawer
      anchor='right'
      open={isOpen}
      onClose={hideEsmeForm}
      classes={{ paper: classes.drawerPaper }}
    >
      { renderForm() }
    </Drawer>
  );
};

export default EsmeFormContainer;
